import { useDebounce, useWindowSize } from "react-use"

export const useViewerResize = (
  onResize: () => void,
  // fontSizeRatio?: number,
) => {
  const { width, height } = useWindowSize()

  useDebounce(onResize, 250, [width, height])
}
